import React, { useMemo } from "react";
import { FooterCopyright, FooterLiens, FooterLogo, FooterOperateur } from "../index";
import FooterDescription from "./Content/FooterDescription";
import FooterPartners from "./Partners/FooterPartners";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025.
 */
var FooterMi = function (_a) {
    var children = _a.children, urls = _a.urls;
    var urlsObligatoires = useMemo(function () {
        return urls
            ? urls
            : [
                {
                    label: "legifrance.gouv.fr",
                    url: "https://legifrance.gouv.fr",
                },
                {
                    label: "gouvernement.fr",
                    url: "https://gouvernement.fr",
                },
                {
                    label: "service-public.fr",
                    url: "https://service-public.fr",
                },
                {
                    label: "data.gouv.fr",
                    url: "https://www.data.gouv.fr/fr/",
                },
            ];
    }, [urls]);
    var footerLogo = null;
    var footerDescription = null;
    var footerLiens = null;
    var footerCopyright = null;
    var footerOperateur = null;
    var footerPartners = null;
    var recupererElement = function (child) {
        switch (child.type) {
            case FooterLogo:
                footerLogo = child;
                break;
            case FooterOperateur:
                footerOperateur = child;
                break;
            case FooterDescription:
                footerDescription = child;
                break;
            case FooterLiens:
                footerLiens = child;
                break;
            case FooterCopyright:
                footerCopyright = child;
                break;
            case FooterPartners:
                footerPartners = child;
                break;
        }
    };
    if (Array.isArray(children)) {
        children.forEach(function (child) {
            recupererElement(child);
        });
    }
    else {
        recupererElement(children);
    }
    return (React.createElement("footer", { className: "fr-footer", role: "contentinfo", id: "footer" },
        React.createElement("div", { className: "fr-container" },
            React.createElement("div", { className: "fr-footer__body fr-footer__body--operator" },
                React.createElement("div", { className: "fr-footer__brand fr-enlarge-link" },
                    footerLogo,
                    footerOperateur),
                React.createElement("div", { className: "fr-footer__content" },
                    footerDescription,
                    React.createElement("ul", { className: "fr-footer__content-list" }, urlsObligatoires.map(function (urlObligatoire) { return (React.createElement("li", { key: "url-gouvernement-obligatoire-".concat(urlObligatoire.label), className: "fr-footer__content-item" },
                        React.createElement("a", { className: "fr-footer__content-link", href: urlObligatoire.url, target: "_blank" }, urlObligatoire.label))); })))),
            footerPartners,
            React.createElement("div", { className: "fr-footer__bottom" },
                footerLiens,
                footerCopyright))));
};
export default FooterMi;
